import { createTRPCReact } from '@trpc/react-query'
import { httpBatchLink } from '@trpc/client'
import type { AppRouter } from '@edrikom/api'

export const trpc = createTRPCReact<AppRouter>()

export function createTrpcClient() {
  const url = import.meta.env.VITE_API_URL
    ? `${import.meta.env.VITE_API_URL}/trpc`
    : `${window.location.origin}/trpc`

  return trpc.createClient({
    links: [
      // `httpBatchLink`, nu `httpLink`: fiecare cerere tRPC declanșează pe server un
      // SELECT de autentificare care ocupă o conexiune din poolul master (implicit max 10).
      // Fără grupare, o pagină cu 8 query-uri consuma tot poolul exact la încărcare.
      // Gruparea le trimite într-o singură cerere HTTP.
      //
      // ATENȚIE: cu batching, calea devine `/trpc/proc1,proc2`. Hook-ul de rate-limit pe
      // login din `server.ts` verifică apartenența la lista de proceduri, nu egalitatea —
      // dacă se schimbă aici, verifică și acolo.
      httpBatchLink({
        url,
        maxURLLength: 2000,
        headers: () => {
          const token = localStorage.getItem('token')
          return token ? { Authorization: `Bearer ${token}` } : {}
        },
      }),
    ],
  })
}
